import React, { Fragment, useContext } from 'react'
import { filterOptionByPaymentType } from 'app/React/Helpers/StepHelper'
import { useSetVariant } from 'app/React/Components/misc/VariantSetting'
import Tip from 'app/React/Components/misc/Tip'
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

export default function PaymentTypeSetting() {
  const {
    car,
    currentModelYear,
    engineTransmissions,
    lang,
    modelYears,
    order,
    paymentTypes,
    strings,
    setCartItems,
    setInteriorImage,
    setOrder,
  } = useContext(ConfiguratorContext)

  const setVariant = useSetVariant()
  const description = car.paymenttype_setting_description ?? ''

  const onChange = function (key) {
    const oldConfiguration = order.configuration
    const oldPaymentType = order.paymentType
    order.paymentType = key
    setCartItems([])

    if (key !== 'leasing' && order.leasing_price_range !== null) {
      order.leasing_price_range = null
    }

    order.configuration = filterOptionByPaymentType(order.configuration ?? {}, key)
    order.paymentType = key

    setOrder({ ...order })

    if (!order.configuration?.variants || oldPaymentType !== key) {
      setVariant(null, 'paymentType', key, oldConfiguration)
    }

    setInteriorImage(null)

    return true
  }

  const fromPrice = (paymentType) => {
    const paymentTypeKey = paymentType === 'leasing' ? 'min_leasing_price' : 'min_price'
    const _modelYear = modelYears
      .filter(modelYear => paymentType === 'cash' ? modelYear.cash_engine_transmissions.length > 0: modelYear.leasing_engine_transmissions.length > 0)
      .sort((a, b) => (parseInt(a[paymentTypeKey]) < parseInt(b[paymentTypeKey])) ? -1 : 1)

    return paymentType === 'cash' ? _modelYear[0].min_price : _modelYear[0].min_leasing_price
  }

  const options = Object.keys(paymentTypes).filter((key, index) => {
    const engineTransmissionHideOn = engineTransmissions.map((engineTransmission) => engineTransmission.hide_on)
    const paymentTypeEngineTransmissionHideOn = engineTransmissionHideOn.filter((hideOn) => hideOn === key)

    return engineTransmissionHideOn.length !== paymentTypeEngineTransmissionHideOn.length
  }).map((key, index) => {
    return (
      <Fragment key={key}>
        <input id={'pt_' + key} type='radio' checked={key === order.paymentType} onChange={() => onChange(key)}/>
        <label htmlFor={'pt_' + key} className='option' layout='standard'>
          {paymentTypes[key]}
          <span>
            {strings.misc.from}
            {' '}
            {new Intl.NumberFormat(lang).format(fromPrice(key))}
            {' '}
            {key === 'leasing' ? strings.price.formats.leasing : strings.price.formats.cash}
          </span>
        </label>
      </Fragment>
    )
  })

  if (options.length === 1) {
    return null
  }

  return (
    <>
      <div className='setting'>
        <h3 className='config-subtitle'>
          {strings.footer.payment_type}
          {typeof description === 'string' && description.length > 0 ? <Tip button='Ok' content={description}/> : null}
        </h3>
        <div className='config-radio'>{options}</div>
      </div>
      <div className='config-seperator'/>
    </>
  )
}
